// assets/garantia-variant-sync.js
// Mantiene el bloque "Garantía Extendida" (product_bundle) sincronizado con la
// variante seleccionada, sin re-ejecutar el <script> inline de main-product.liquid
// (que registra un listener de click delegado en document — re-ejecutarlo lo
// duplicaría) y sin tocar assets/global.js (compartido por todo el sitio).
(function () {
  'use strict';

  var ITEMS_SELECTOR = '[data-garantia-variant-aware="true"]';

  // Keyed by composite id ("{{ section.id }}-{{ block.id }}").
  // { trueSectionId, compositeId, itemsEl, wrapperEl, popupData, currentVariantId }
  var registry = {};

  function safeParseJson(text) {
    try {
      return JSON.parse(text);
    } catch (e) {
      console.error('[garantia-variant-sync] Invalid JSON in popup data island', e);
      return null;
    }
  }

  function initContainer(itemsEl) {
    var productInfoEl = itemsEl.closest('product-info');
    var blockWrap = itemsEl.closest('[data-section-id]');
    if (!productInfoEl || !blockWrap) return; // markup no es el esperado, no hacer nada

    var trueSectionId = productInfoEl.getAttribute('data-section');
    var compositeId = blockWrap.getAttribute('data-section-id');
    if (!trueSectionId || !compositeId || registry[compositeId]) return;

    var dataEl = document.getElementById('garantia-popup-data-' + compositeId);
    var popupData = {};
    if (dataEl) {
      var parsed = safeParseJson(dataEl.textContent || '{}');
      if (parsed) popupData = parsed;
    }

    registry[compositeId] = {
      trueSectionId: trueSectionId,
      compositeId: compositeId,
      itemsEl: itemsEl,
      wrapperEl: itemsEl.closest('.product-bundle-block'),
      popupData: popupData,
      currentVariantId: itemsEl.getAttribute('data-current-variant-id') || null
    };
  }

  function patchGetProductMetafieldContent() {
    if (typeof window.getProductMetafieldContent !== 'function') return;
    if (window.getProductMetafieldContent.__garantiaWrapped) return; // idempotente

    var original = window.getProductMetafieldContent;

    var wrapped = function (productId) {
      for (var compositeId in registry) {
        if (!Object.prototype.hasOwnProperty.call(registry, compositeId)) continue;
        var entry = registry[compositeId];
        var variantId = entry.currentVariantId;
        var variantMap = variantId ? entry.popupData[variantId] : null;
        if (variantMap && Object.prototype.hasOwnProperty.call(variantMap, productId)) {
          return variantMap[productId];
        }
      }
      return original(productId);
    };
    wrapped.__garantiaWrapped = true;
    window.getProductMetafieldContent = wrapped;
  }

  function applyVariantSwap(entry, newVariantId, freshHtmlDoc) {
    entry.currentVariantId = newVariantId;
    if (entry.itemsEl) {
      entry.itemsEl.setAttribute('data-current-variant-id', newVariantId || '');
    }

    if (!freshHtmlDoc) return;

    var freshItems = freshHtmlDoc.getElementById('products-' + entry.compositeId);

    if (freshItems && entry.itemsEl) {
      entry.itemsEl.innerHTML = freshItems.innerHTML;
    }

    // El contenedor #products- SIEMPRE existe en el HTML (fix "shell always
    // render"), así que su sola presencia ya no indica que haya garantía real.
    // Se valida que haya al menos un .product-bundle__item renderizado.
    var hasRealItems = !!(freshItems && freshItems.querySelector('.product-bundle__item'));

    if (entry.wrapperEl) {
      entry.wrapperEl.style.display = hasRealItems ? '' : 'none';
    }
  }

  function subscribeToVariantChange(attempt) {
    attempt = attempt || 0;
    if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined' || !PUB_SUB_EVENTS.variantChange) {
      if (attempt > 40) return; // ~2s de reintentos, luego se rinde en silencio
      window.setTimeout(function () {
        subscribeToVariantChange(attempt + 1);
      }, 50);
      return;
    }

    subscribe(PUB_SUB_EVENTS.variantChange, function (event) {
      var data = event && event.data;
      if (!data || !data.sectionId) return;

      for (var compositeId in registry) {
        if (!Object.prototype.hasOwnProperty.call(registry, compositeId)) continue;
        var entry = registry[compositeId];
        if (entry.trueSectionId !== data.sectionId) continue;

        var newVariantId = data.variant && data.variant.id != null ? String(data.variant.id) : null;
        applyVariantSwap(entry, newVariantId, data.html);
      }
    });
  }

  function init() {
    var containers = document.querySelectorAll(ITEMS_SELECTOR);
    containers.forEach(initContainer);

    if (Object.keys(registry).length === 0) return; // no hay bloque de garantía en esta página/variante

    patchGetProductMetafieldContent();
    subscribeToVariantChange();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
